# Host inputs from the URL must not contain authority-breakout characters
# (/ # : @ ? \ or whitespace), which could redirect the connection — and the
# token it carries — to an attacker host. See VUL-516.
# `environment` is a single datacentre label; `cname` is a full hostname (dots ok).
SAFE_HOST_SEGMENT = /^[a-z0-9-]+$/
SAFE_HOSTNAME = /^[a-z0-9.-]+$/

window.Debug =
  init: ->
    @setupInstanceVars()
    @setupEvents()
    @setupLogCapture()
    @prefillFields()

    if @getParameterByName('autorun') == "true"
      unless @apiKeyField.val().match(/.+:.*/)
        alert 'Please enter a valid API key before continuing'
        return
      @prepare key: @apiKeyField.val().replace(/^\s*|\s*$/, '')

  setupInstanceVars: ->
    @keyActions = $('#key-actions')
    @continueBtn = $('#continue-btn')
    @skipApiKeyBtn = $('#no-api-key')
    @apiKeyField = $('#api-key')
    @email = $('#email')

    @testsPanel = $('#running-tests')
    @runningProgress = $('#running-progress')
    @logOutput = $('#log')

    @uploadingPanel = $('#uploading')
    @uploadingProgress = $('#uploading-progress')

    @completePanel = $('#complete')
    @uuidMessage = $('#uuid-message')

    console.log " ---- Debug custom options (append queryparams to the URL) ----"
    console.log "   channel:     use the specified channel instead of a random channel"
    console.log "   environment: endpoint name such as eu or acme to test a dedicated cluster (resolves to <endpoint>.realtime.ably.net)"
    console.log "   cname:       specify a single custom CNAME to test against"
    console.log "   key:         prefill the API key input with this value"
    console.log "   autorun:     if 'true', initiate the test on page load"
    console.log "   level:       set the Ably client log level (1-4)"

  setupEvents: ->
    @continueBtn.on 'click', (event) =>
      event.preventDefault()
      unless @apiKeyField.val().match(/.+:.*/)
        alert 'Please enter a valid API key before continuing'
        return
      @prepare key: @apiKeyField.val().replace(/^\s*|\s*$/, '')

    @skipApiKeyBtn.on 'click', (event) =>
      event.preventDefault()
      @prepare authUrl: 'https://ably.com/ably-auth/token/demos'

  setupLogCapture: ->
    @consoleLogs = []

    patchConsole = (method) =>
      oldMethod = console[method]
      console[method] = =>
        oldMethod.apply console, arguments
        message = Array.prototype.slice.call(arguments).join(' ')
        stack = if message.match(/error|warn|fatal/i) then new Error().stack else null
        @consoleLogs.push({
          method: method,
          time: Date.now(),
          message: message,
          stack: stack
        })

    patchConsole method for method in ['log', 'info', 'warn', 'error']

  prefillFields: ->
    keyFromParam = @getParameterByName('key')

    if keyFromParam
      @apiKeyField.val(keyFromParam)


  log: (message) ->
    @logOutput.text "#{@logOutput.text()}#{new Date().toUTCString()} - #{message} \n"
    @logOutput[0].scrollTop = @logOutput[0].scrollHeight

  delay: (time, cb) ->
    setTimeout(cb, time)

  prepare: (clientOptions) ->
    @apiKeyField.attr 'disabled', 'disabled'
    @keyActions.hide()
    @testsPanel.removeClass('hide')
    @scrollIntoView @testsPanel

    @log "-- Device Detected --"
    @log "   userAgent: #{navigator.userAgent}"
    uaData = navigator.userAgentData
    if uaData
      brands = ("#{brand.brand} #{brand.version}" for brand in (uaData.brands ? [])).join(', ')
      @log "   brands: #{brands}" if brands
      @log "   mobile: #{uaData.mobile}"
      @log "   platform: #{uaData.platform}"
    @log "\n"

    @log "-- Getting Geolocation Data --"
    $.getJSON('//freegeoip.net/json/').done((data) =>
      for attribute, val of data
        @log "   #{attribute}: #{val}"
      @log "\n"
    ).fail(=>
      @log "-- [ERROR] Unable to obtain Geolocation data, tests will continue --\n"
    ).always(=>
      @runTests clientOptions
    )

  runTests: (clientOptions) ->
    @keyUsed = clientOptions.key || clientOptions.authUrl
    clientOptions = Object.assign(@defaultOptions(), clientOptions)

    levelFromParam = parseInt(@getParameterByName('level') || 1, 10)
    clientOptions.log = {
      level: levelFromParam
      handler: (message) => @log message
    }

    @log "-- Starting WebSocket connect tests (test 1 of 9) --\n"
    @runConnectMultipleTimesTests Object.assign({}, clientOptions, { transports: ['web_socket'] }), (err) =>
      if err
        @log "-- [ERROR] Completed WebSocket connect tests with error: #{err} --"
      else
        @log "-- Completed WebSocket connect tests --\n"

      @log "-- Starting XHR Streaming connect tests (test 2 of 9) --\n"
      @runConnectMultipleTimesTests Object.assign({}, clientOptions, { transports: ['xhr_streaming'] }), (err) =>
        if err
          @log "-- [ERROR] Completed XHR Streaming connect tests with error: #{err} --\n"
        else
          @log "-- Completed XHR Streaming connect tests --\n"

        @log "-- Starting XHR Polling connect tests (test 3 of 9) --\n"
        @runConnectMultipleTimesTests Object.assign({}, clientOptions, { transports: ['xhr_polling'] }), (err) =>
          if err
            @log "-- [ERROR] Completed XHR connect tests with error: #{err} --\n"
          else
            @log "-- Completed XHR Polling connect tests --\n"

          @log "-- Starting WebSocket channel tests (test 4 of 9) --\n"
          @runChannelTests Object.assign({}, clientOptions, { transports: ['web_socket'] }), {}, (err) =>
            if err
              @log "-- [ERROR] Completed WebSocket channel tests with error: #{err} --\n"
            else
              @log "-- Completed WebSocket channel tests --\n"

            @log "-- Starting XHR Streaming channel tests (test 5 of 9) --\n"
            @runChannelTests Object.assign({}, clientOptions, { transports: ['xhr_streaming'] }), {}, (err) =>
              if err
                @log "-- [ERROR] Completed XHR Streaming channel tests with error: #{err} --\n"
              else
                @log "-- Completed XHR Streaming channel tests --\n"

              @log "-- Starting XHR Polling channel tests (test 6 of 9) --\n"
              @runChannelTests Object.assign({}, clientOptions, { transports: ['xhr_polling'] }), {}, (err) =>
                if err
                  @log "-- [ERROR] Completed XHR Polling channel tests with error: #{err} --\n"
                else
                  @log "-- Completed XHR Polling channel tests --\n"

                @log "-- Starting WebSocket channel tests with delayed publishing (test 7 of 9) --\n"
                @runChannelTests Object.assign({}, clientOptions, { transports: ['web_socket'] }), publishDelay: 60000, (err) =>
                  if err
                    @log "-- [ERROR] Completed WebSocket channel tests with error: #{err} --\n"
                  else
                    @log "-- Completed WebSocket channel tests --\n"

                  @log "-- Starting XHR Streaming channel tests with delayed publishing (test 8 of 9) --\n"
                  @runChannelTests Object.assign({}, clientOptions, { transports: ['xhr_streaming'] }), publishDelay: 60000, (err) =>
                    if err
                      @log "-- [ERROR] Completed XHR Streaming channel tests with error: #{err} --\n"
                    else
                      @log "-- Completed XHR Streaming channel tests --\n"

                    @log "-- Starting XHR Polling channel tests with delayed publishing (test 9 of 9) --\n"
                    @runChannelTests Object.assign({}, clientOptions, { transports: ['xhr_polling'] }), publishDelay: 60000, (err) =>
                      if err
                        @log "-- [ERROR] Completed XHR Polling channel tests with error: #{err} --\n"
                      else
                        @log "-- Completed XHR Polling channel tests --\n"

                      @uploadResults()

  uploadResults: ->
    @runningProgress = $('#running-progress').hide()
    @uploadingPanel.removeClass('hide')
    @scrollIntoView @uploadingPanel

    consoleLogs = for log in @consoleLogs
      stackMessage = if log.stack then "\n#{log.stack.replace(/.+\n+/, '')}" else ''
      "#{log.time} [#{log.method}] #{log.message}#{stackMessage}"

    log = "#{@logOutput.text()}\n\n ------- CONSOLE LOG -------\n\n#{consoleLogs.join("\n")}"
    email = @email.val() unless @email.length is 0

    uploadRequestOptions =
      url: '/debug-result'
      type: 'POST'
      data: JSON.stringify(key: @keyUsed, log: log, email: email)
      contentType:"application/json; charset=utf-8"
      dataType: "json"

    $.ajax(uploadRequestOptions).done((data) =>
      @complete data.uuid
    ).fail(=>
      @log "-- [ERROR] We could not send the results to the Ably web server"
      alert('We are sorry.\nUnfortunately there has been an error sending the results to our Ably web server.\nPlease contact us now so that we can help diagnose the problem')
    )

  complete: (uuid) ->
    @uuidMessage.html("We've got you results. The code is <strong>#{uuid}</strong>.")
    @uploadingProgress.hide()
    @completePanel.removeClass('hide')
    @scrollIntoView @completePanel

  runConnectMultipleTimesTests: (clientOptions, cb) ->
    connnectionsToOpen = 15
    connectedCount = 0

    done = (error) =>
      clearTimeout timeout
      for connection in connections
        connection.close()
      cb(error)

    setupConnection = (connectionId) =>
      clientEnvironment = document.getElementById('ably-client-script').getAttribute('data-env')
      ably = new Ably.Realtime((Object.assign({ autoConnect: false, environment: clientEnvironment }, clientOptions)))

      @delay connectionId * 2500, =>
        ably.connection.connectionManager.once 'transport.pending', (state) ->
          transport = ably.connection.connectionManager.pendingTransports[0]
          originalOnProtocolMessage = transport.onProtocolMessage

          transport.onProtocolMessage = (message) ->
            ably.connectionDetails = message.connectionDetails if message.action == 4
            originalOnProtocolMessage.call transport, message

        ably.connection.on 'connected', =>
          @log "Connection #{connectionId} is connected - #{JSON.stringify(ably.connectionDetails)}"
          ably.close()
          connectedCount += 1
          done() if connectedCount == connnectionsToOpen
        ably.connection.on 'disconnected', =>
          @log "[ERROR] Connection #{connectionId} disconnected"
          done "Connection moved to unexpected disconnected state"
        ably.connection.on 'failed', =>
          @log "[ERROR] Connection #{connectionId} failed"
          done "Connection moved to unexpected failed state"

        @log "Opening new connection #{connectionId}"
        ably.connect()

      ably

    connections = for connectionId in [1..connnectionsToOpen]
      setupConnection(connectionId)

    timeout = @delay 60000, =>
      done "Timed out after 60s"

  runChannelTests: (clientOptions, testOptions, cb) ->
    publishDelay = if testOptions.publishDelay then testOptions.publishDelay else 0 # ms
    messagesToSend = 50
    messagesToSend = 50
    messagesSent = {}
    receivedCount = 0
    publishedCount = 0
    channelName = @getParameterByName('channel') || @randomString()
    attachedCount = 0

    if publishDelay > 0
      @log "Attaching to channel #{channelName}. Messages will be published after a delay of #{publishDelay / 1000}s."
    else
      @log "Attaching to channel #{channelName}"

    ablyPublisher = new Ably.Realtime(clientOptions)
    channelPublisher = ablyPublisher.channels.get(channelName)
    ablySubscriber = new Ably.Realtime(clientOptions)
    channelSubscriber = ablyPublisher.channels.get(channelName)

    done = (error) =>
      clearTimeout timeout
      ablyPublisher.close()
      ablySubscriber.close()
      acks = 0
      avgAck = 0
      roundtrips = 0
      avgRoundtrip = 0
      errs = 0

      for id, message of messagesSent
        if message.ackDuration
          acks += 1
          avgAck += message.ackDuration
        if message.roundtripDuration
          roundtrips += 1
          avgRoundtrip += message.roundtripDuration
        errs += 1 if message.error

      avgAck = avgAck / acks
      avgRoundtrip = avgRoundtrip / roundtrips

      @log "::Channel publish stats:: average round-trip #{Math.round(avgRoundtrip)}ms, average publish ACK #{Math.round(avgAck)}ms, errors #{errs}"

      cb(error)

    channelSubscriber.subscribe (message) =>
      messageId = Number(message.name)
      @log "Received #{messageId} messages" if messageId % 10 == 0
      messagesSent[messageId].roundtripDuration = Date.now() - messagesSent[messageId].sent
      receivedCount += 1
      done() if receivedCount == publishedCount == messagesToSend

    publishMessage = (messageId) =>
      delay = messageId * 400 + publishDelay
      @delay delay, => # No more than 2.5 messages a second for this test
        channelPublisher.publish messageId.toString(), @randomString(256), (err) =>
          publishedCount += 1
          if err
            messagesSent[messageId].error = err
            @log "[ERROR] Could not publish message ID #{messageId}: #{err}"
          else
            messagesSent[messageId].ackDuration = Date.now() - messagesSent[messageId].sent
          done() if receivedCount == publishedCount == messagesToSend

        messagesSent[messageId] = { sent: Date.now() }

        @log "Published #{messageId} messages" if messageId % 10 == 0

    for channel in [channelPublisher, channelSubscriber]
      channel.once 'attached', =>
        attachedCount += 1
        @log "Channel #{attachedCount}/2 #{channelName} attached"
        if attachedCount == 2
          publishMessage messageId for messageId in [1..messagesToSend]

      channel.once 'failed', =>
        @log "[ERROR] Channel failed"
        done "Channel failed"

      channel.attach((err) =>
        if err
          @log "[ERROR] Channel attach failed"
          done "Channel attach failed: #{err}"
      )

    testTimeout = 60000 + publishDelay
    timeout = @delay testTimeout, =>
      done "Timed out after #{testTimeout / 1000}s"

  scrollIntoView: ($elem) ->
    offset = $elem.offset()
    offset.top -= 100
    $('html, body').animate({
      scrollTop: offset.top,
      scrollLeft: offset.left
    })

  defaultOptions: ->
    # useTokenAuth keeps the API key secret off the wire — the token request is
    # signed locally. Scoping it (pub/sub only), pinning clientId and a short ttl
    # mean a captured request can be replayed for very little.
    endpointParam = @getParameterByName('environment')
    endpoint = if endpointParam && SAFE_HOST_SEGMENT.test(endpointParam) then endpointParam else 'main'
    console.warn("Ignoring invalid environment parameter; falling back to 'main'") if endpointParam && endpoint != endpointParam
    host = "#{endpoint}.realtime.ably.net"
    options = {
      useTokenAuth: true
      clientId: 'ably-debug'
      defaultTokenParams: {
        capability: '{"*":["publish","subscribe"]}'
        ttl: 300000
      }
      realtimeHost: host
      restHost: host
    }
    cname = @getParameterByName('cname')
    if cname
      if SAFE_HOSTNAME.test(cname)
        options.realtimeHost = cname
        options.restHost = cname
      else
        console.warn("Ignoring invalid cname parameter; falling back to default host")
    options

  getParameterByName: (name, url) ->
    url = window.location.href unless url
    name = name.replace(/[\[\]]/g, "\\$&")
    regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")
    results = regex.exec(url)
    return null unless results
    return '' unless results[2]
    decodeURIComponent(results[2].replace(/\+/g, " "))

  randomString: (length = 5)->
    text = ""
    possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
    for index in [0..length-1]
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    text
